import { Injectable } from '@angular/core';

import { Nucleo, NucleoPage } from '../shared/types'

import { WP_API_URL } from 'app/config'

const PAGE_API_URL = 'https://www.extranet.ceuma.br/ceuma-wordpress/wp-json/wp/v2' + '/pages';
const NUCLEOS_PAGE_API_URL = PAGE_API_URL + '/27933'

const POSTS_API_URL = 'https://www.extranet.ceuma.br/ceuma-wordpress/wp-json/wp/v2' + '/posts';
const NUCLEOS_API_URL = POSTS_API_URL + '?categories=1760'

@Injectable()
export class NucleoService {

  constructor() {}

  async getNucleos(): Promise<Nucleo[]> {
    const data = await fetch(NUCLEOS_API_URL)
    const result = await data.json()

    return result
  }

  async getInformationsPage(): Promise<NucleoPage> {
    const data = await fetch(NUCLEOS_PAGE_API_URL)
    const result = await data.json()

    return result
  }

  async getImage(path: string): Promise<string> {
    const data = await fetch(path)
    const result = await data.json()

    const href = result.guid.rendered

    return href
  }

  async getDetailsInfo(slug): Promise<Nucleo> {
    const url = `${NUCLEOS_API_URL}&slug=${slug}`

    const data = await fetch(url)
    const result = await data.json()

    return result
  }

}
